module.exports = __webpack_public_path__ + "static/chair-22d468d3ba2f51d2a43e535a8b7b37b2.jpg";